import React from "react"
import {Button} from "@mui/material"
import LanguageIcon from "@mui/icons-material/Language"
import {useLanguages} from "../hooks/useLanguageData"
import {useLanguage} from "../context/LanguageContext"

const LanguageSelector = () => {
  const {loading, error} = useLanguages()
  const {language, changeLanguage} = useLanguage()

  const handleLanguageChange = () => {
    if (language === "EN") {
      changeLanguage("TR", "3")
    } else {
      changeLanguage("EN", "4")
    }
  }

  if (loading) return <div>Loading languages...</div>
  if (error) return <div>Error: {error}</div>

  return (
    <div style={{display: "flex", alignItems: "center"}}>
      <div>
        <Button
          startIcon={<LanguageIcon />}
          color="inherit"
          onClick={handleLanguageChange}
        >
          {language === "EN" ? "EN" : "TR"}
        </Button>
      </div>
      {/* You can uncomment this if you want to list all languages dynamically */}
      {/* 
      <div>
        {languages.map((lang) => (
          <Button
            key={lang.code}
            onClick={() => handleLanguageChange()}
            color="inherit"
            style={{ marginBottom: "8px", textTransform: "none" }}
          >
            {lang.name}
          </Button>
        ))}
      </div>
      */}
    </div>
  )
}

export default LanguageSelector
